module.exports = __webpack_public_path__ + "static/media/mobile-bg.c9a73605.png";